import React from 'react';
import update from "immutability-helper/index";
import RenderText from './editorfields/text'
import RenderConditionalLogic from './editorfields/conditionalLogic'
import RenderSectionID from './editorfields/SectionID'
import RenderToggle from './editorfields/Toggle'
import RenderOptions from './editorfields/Options'
import Instructions from './editorfields/Instructions'
import ElementID from './editorfields/ElementID'
import {RenderSelect} from './editorfields/Select'
import Textarea from './editorfields/Textarea'
import RenderPrice from './editorfields/RenderPrice'
import style from './Tabcontents.scss'

const validateField = (item, field, value) => {
    let valid = true;
    if (typeof item.validation !== 'undefined' && item.validation.length) {
        item.validation.forEach((e) => {
            switch (e.type) {
                case "required":
                    if (typeof value === 'string' && value.trim() === '') {
                        valid = {status: false, message: 'Field is required'}
                    }

            }
        })
    }
    return valid;
}

const Tabcontents = (props) => {
    const {schema, openTabs, field, switchTab} = props;
    const {tabLabels, checkIsReadOnly} = props;



    const tabs = schema.map((e) => {
        return e.group ? e.group : 'general';
    }).filter((value, index, self) => {
        return self.indexOf(value) === index; // for keeping unique
    });


    return (
        <>
            {
                tabs.map(key => {
                    const attrs = schema.filter((e) => {
                        return e.group === key
                    });

                    return (
                        <div className={style.wrap}>
                            <div className={style.tabCtl + " " + ((openTabs.indexOf(key) !== -1) && style.active)}
                                 onClick={() => {
                                     return props.switchTab(key)
                                 }}
                            ><img src={tabLabels[key].icon}/> {tabLabels[key].label}
                            </div>
                            <div className={style.tabContent}>
                                {(openTabs.indexOf(key) !== -1) && <div className={style.tabCntwrp} key={key}>
                                    {attrs.map(e => {
                                        const isReadOnly = checkIsReadOnly(field, e);

                                        if (typeof e.conditions !== 'undefined') {
                                            let skippField = false;
                                            for (let i = 0; i < e.conditions.length; i++) {
                                                if (e.conditions[i].type === 'field') {
                                                    if (field[e.conditions[i].field] !== e.conditions[i].value) {
                                                        skippField = true;
                                                        break;
                                                    }
                                                } else if (e.conditions[i].type === 'defaultLang') {
                                                    if (window.awcfe_object.isMlActive && window.awcfe_object.ml.isDefault !== e.conditions[i].value) {
                                                        skippField = true;
                                                        break;
                                                    }
                                                }
                                            }
                                            if (skippField) {
                                                return null;
                                            }
                                        }

                                        switch (typeof e.render === 'object' ? e.render.type : e.render) {

                                            case 'instructions':
                                                return (

                                                    <Instructions
                                                        key={e.item}
                                                        item={e}
                                                        field={field}

                                                    />
                                                )

                                            case 'text':
                                                return (

                                                    <RenderText
                                                        key={e.item + (e.item === 'name' && field.label)}
                                                        item={e}
                                                        field={field}
                                                        isReadOnly={isReadOnly}
                                                        validateField={validateField}
                                                        handleChange={(value) => {

                                                            return props.handleChange(update(field, {[e.item]: {$set: value}}))

                                                        }
                                                        }/>
                                                )
                                            case 'number':
                                                return (

                                                    <RenderText
                                                        key={e.item + (e.item === 'name' && field.label)}
                                                        item={e}
                                                        field={field}
                                                        isReadOnly={isReadOnly}
                                                        validateField={validateField}
                                                        type="number"
                                                        min={field.min}
                                                        handleChange={(value) => {

                                                            return props.handleChange(update(field, {[e.item]: {$set: value}}))

                                                        }
                                                        }/>
                                                )
                                            case 'textarea':
                                                return (

                                                    <Textarea
                                                        key={e.item + (e.item === 'name' && field.label)}
                                                        item={e}
                                                        field={field}
                                                        validateField={validateField}
                                                        isReadOnly={isReadOnly}
                                                        handleChange={(value) => {

                                                            return props.handleChange(update(field, {[e.item]: {$set: value}}))

                                                        }
                                                        }

                                                    />
                                                )
                                            case 'section_id':
                                                return (

                                                    <RenderSectionID key={e.item} item={e} field={field}
                                                                     handleChange={(value) => {
                                                                         return props.handleChange(update(field, {[e.item]: {$set: value}}))

                                                                     }
                                                                     }/>
                                                )
                                            case 'elementId':
                                                return (

                                                    <ElementID
                                                        key={e.item}
                                                        item={e}
                                                        field={field}

                                                    />
                                                )
                                            case 'select':
                                                return (
                                                    <RenderSelect
                                                        key={e.item}
                                                        item={e}
                                                        field={field}
                                                        isReadOnly={isReadOnly}
                                                        handleChange={(value) => {
                                                            return props.handleChange(update(field, {[e.item]: {$set: value}}))

                                                        }
                                                        }
                                                    />
                                                )
                                            case 'toggle':
                                                return (

                                                    <RenderToggle
                                                        key={e.item}
                                                        item={e}
                                                        field={field}
                                                        isReadOnly={isReadOnly}
                                                        handleChange={
                                                            (value) => {
                                                                return props.handleChange(update(field, {[e.item]: {$set: value}}))

                                                            }
                                                        }
                                                    />
                                                )

                                            case 'conditional_logic':

                                                return (
                                                    <RenderConditionalLogic
                                                        isEnabled={(typeof field.enableCl === 'undefined' || field.enableCl === false)}
                                                        key={e.item}
                                                        item={e}
                                                        field={field}
                                                        isReadOnly={isReadOnly}
                                                        handleChange={(value) => {

                                                            return props.handleChange(value)
                                                        }
                                                        }
                                                    />
                                                    // <RenderConditionalLogic key={e.item} item={e} field={field}
                                                    //     handleChange={(value) => {
                                                    //         return props.handleChange(update(field, {[e.item]: {$set: value}}))
                                                    //     }
                                                    //     }/>
                                                )
                                                case 'price':
                                                  return (

                                                      <RenderPrice
                                                          key={e.item }
                                                          item={e}
                                                          field={field}
                                                          isReadOnly={isReadOnly}
                                                          validateField={validateField}
                                                          handleChange={(value) => {

                                                              return props.handleChange(value)

                                                          }
                                                          }/>
                                                  )


                                            case 'options':
                                                return (
                                                    <RenderOptions
                                                        key={e.item}
                                                        item={e} field={field}
                                                        isReadOnly={isReadOnly}
                                                        handleChange={(value) => {
                                                            return props.handleChange(update(field, {[e.item]: {$set: value}}))
                                                        }
                                                        }/>
                                                )

                                            default:
                                                return (

                                                    <RenderText key={e.item} item={e} field={field}
                                                                handleChange={(value) => {
                                                                    return props.handleChange(update(field, {[e.item]: {$set: value}}))

                                                                }
                                                                }/>
                                                )

                                        }
                                    })
                                    }
                                </div>
                                }

                            </div>
                        </div>
                    )
                })}

        </>
    )
};

export default Tabcontents;
